import {keepPreviousData, queryOptions, useQuery} from "@tanstack/react-query";

import * as apiClient from '@/lib/api'
import {AdvisersData} from "@/modules/advisers/advisers-table/types";
import {FetchParamsWithRequiredOrderBy} from "@/types/search";
import {FIVE_MINUTES} from "@/utils/constants";
import {QUERY_KEY_ADVISERS_TYPE} from "@/utils/keys";

const {VITE_QUERY_STALE_TIME} = import.meta.env

const buildQueryParamsString = (fetchParams: FetchParamsWithRequiredOrderBy): string => {
  const queryParams = new URLSearchParams()

  queryParams.append("limit", fetchParams.limit.toString())
  queryParams.append("offset", fetchParams.offset.toString())

  const orderByCol = fetchParams.order_by.column
  const orderByDirection = fetchParams.order_by?.direction
  queryParams.append(`order_by[professional.${orderByCol}]`, orderByDirection)

  return queryParams.toString()
}

function fetchAdvisers(fetchParams: FetchParamsWithRequiredOrderBy): Promise<AdvisersData> {
  return apiClient.get(`/firm/professionals/adviser-settings?${buildQueryParamsString(fetchParams)}`, true)
}


export const advisersQueryOptions = (
  fetchParams: FetchParamsWithRequiredOrderBy,
) =>
  queryOptions({
    queryKey: [QUERY_KEY_ADVISERS_TYPE, fetchParams],
    queryFn: () => fetchAdvisers(fetchParams),
    placeholderData: keepPreviousData,
    staleTime: VITE_QUERY_STALE_TIME ? Number(VITE_QUERY_STALE_TIME) : FIVE_MINUTES,
  });

export const useAdvisers = (fetchParams: FetchParamsWithRequiredOrderBy) => {
  const query =  useQuery(advisersQueryOptions(fetchParams))

  return {
    data: query.data?.data ?? [],
    total: query.data?.aggregate_data?.total ?? 0,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isPlaceholderData: query.isPlaceholderData,
    isError: query.isError,
    isRefetchError: query.isRefetchError,
    error: query.error,
    isRefetching: query.isRefetching,
    isSuccess: query.isSuccess,
    status: query.status
  }
}